export default __webpack_public_path__ + "static/media/uncontact.373a5fbb.svg";